<template>
  <div
    v-bind:data-BoardId="item._id"
    v-bind:class="'statusTaskItemCls-' + item._id"
    class="list-group-item tsk_item_card_cls boardClsId"
    v-for="element in item.data"
    :key="element.title"
  >
    <div class="itemMainCls taskTitleCls" v-bind:dataId="element.task_id">
      <input
        type="hidden"
        name="taskId"
        class="taskId"
        v-bind:class="'taskId-' + element.task_id"
        v-bind:value="element.task_id"
      />
      <div
        class="kanTImgsCls"
        :class="element.task_id + 'imgs'"
        v-if="isImage(element.attachmentsImage)"
      >
        <img
          v-bind:src="img_url + '' + element.attachmentsImage"
          class="img-thumbnail"
          style="width: 100%"
          @error="imageLoadError(element.task_id)"
        />
      </div>
      <div class="kanTitleCls">
        <!-- <div v-html="readMore(element.title, element.task_id)" />      -->
        <span v-bind:class="'kanTitCls-' + element.task_id">{{ element.title }}</span>
        <b>#{{ element.task_no }}</b>
      </div>
      <div class="kanPriNameMainCls" v-bind:class="'kanPriCls-' + element.task_id">
        <div class="kanPriNameCls" v-if="element.priority">
          <p
            v-tooltip="
              dateChangeFormat(element.lastActivityDate || element.taskCreatedDate)
            "
            :class="getTimeClassByElement(element)"
            style="margin: 0"
          >
            <i>
              <template v-if="element.lastActivityDate">
                {{ formatDateRange(element.taskCreatedDate, element.lastActivityDate) }}
              </template>

              <template v-else>
                {{ formatDateOnlyStartRange(element.taskCreatedDate) }}
              </template>
            </i>
          </p>
        </div>
      </div>
      <div class="kanPriNameMainCls" v-bind:class="'kanPriCls-' + element.task_id">
        <div class="kanPriNameCls"></div>
        
        <div
          class="tsk_priority_main"
          v-bind:class="'kanLabelCls-' + element.task_id"
          v-html="labelsHtml(element.labels, element.color, element.priority)"
        />
      </div>
      <div class="kanTitleCls">
        <div class="float-right ms-0"></div>
      </div>
      <div class="kanPriFooterCls">
        <div class="kanFooterCmt_right">
          <div class="kanFooterDateCls float-left ms-0">
            <div class="float-right ms-0">{{ dateFormate(element.taskCreatedDate) }}</div>
          </div>
          <div class="kanFooterCmtCls float-left ms-2">
            <CommentSvgIcon />
            <div class="float-right ms-1">{{ element.commentsCounts }}</div>
            <div class="clearfix"></div>
          </div>
          <div class="kanFooterAttCls float-left ms-2">
            <AttachmentSvgIcon />
            <input
              type="hidden"
              v-bind:class="'atCntVal-' + element.task_id"
              v-bind:value="element.attachmentsCounts"
            />
            <div class="float-right ms-1" v-bind:class="'atCnt-' + element.task_id">
              {{ element.attachmentsCounts }}
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="kanFooterCmt_left">
          <div class="kanTitleClssdsd" v-bind:class="'kanUsersCls-' + element.task_id">
            <div class="tsk_assign_user" v-html="userImgHtml(element.users)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CommentSvgIcon from "../Widgets/Icon/CommentSvgIcon.vue";
import AttachmentSvgIcon from "../Widgets/Icon/AttachmentSvgIcon.vue";
import defaultUser from "@/assets/images/default-user.png";
import $ from "jquery";
import moment from "moment";
export default {
  name: "karbanItemPage",
  components: {
    CommentSvgIcon,
    AttachmentSvgIcon,
  },
  props: {
    item: {
      type: [Object, Array], // ❌ This expects an array
      required: true,
    },
  },
  data() {
    return {
      img_url: process.env.VUE_APP_IMG_URL,
      defaultImage: defaultUser,
    };
  },
  methods: {
    dateChangeFormat(dateVal) {
      return (
        moment(dateVal).format("DD MMM YYYY") + " at " + moment(dateVal).format("hh:mm A")
      );
    },
    getTimeClassByElement(element) {
      let diffMs = 0;

      // SAME logic as text
      if (element.lastActivityDate) {
        diffMs = Math.abs(
          new Date(element.lastActivityDate) - new Date(element.taskCreatedDate)
        );
      } else {
        diffMs = Math.abs(Date.now() - new Date(element.taskCreatedDate));
      }

      const minutes = Math.floor(diffMs / 60000);

      if (minutes <= 10) return "time-green";
      if (minutes <= 15) return "time-light-green";
      if (minutes <= 30) return "time-yellow";
      if (minutes <= 45) return "time-orange";
      if (minutes <= 60) return "time-dark-orange";
      return "time-red";
    },
    formatDateRange(start, end) {
      if (!start || !end) return "-";

      const startDate = new Date(start);
      const endDate = new Date(end);

      let diffMs = Math.abs(endDate - startDate);

      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      diffMs %= 1000 * 60 * 60 * 24;

      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      diffMs %= 1000 * 60 * 60;

      const minutes = Math.floor(diffMs / (1000 * 60));

      let result = [];

      if (days) result.push(`${days} day${days > 1 ? "s" : ""}`);
      if (hours) result.push(`${hours} hour${hours > 1 ? "s" : ""}`);
      if (minutes || result.length === 0)
        result.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);

      return result.join(" ");
    },
    formatDateOnlyStartRange(start) {
      if (!start) return "-";

      const startDate = new Date(start);

      let diffMs = Math.abs(Date.now() - startDate);

      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      diffMs %= 1000 * 60 * 60 * 24;

      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      diffMs %= 1000 * 60 * 60;

      const minutes = Math.floor(diffMs / (1000 * 60));

      let result = [];

      if (days) result.push(`${days} day${days > 1 ? "s" : ""}`);
      if (hours) result.push(`${hours} hour${hours > 1 ? "s" : ""}`);
      if (minutes || result.length === 0)
        result.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);

      return result.join(" ");
    },

    imageLoadError(id) {
      // console.log('Image failed to load', id);
      $("." + id + "imgs").hide();
    },
    dateFormate(date1) {
      // return moment(date1).format('YYYY-MM-DD HH:mm:ss')
      return moment(date1).format("DD MMM");
    },
    isImage(filePath) {
      if (!filePath) return false;
      const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
      return imageExtensions.test(filePath);
    },
    labelsHtml(labels, color, priority) {
      var len = labels.length;
      var htmls = "";
      htmls += `<div class="kanPriNameCls"><div style="background: ${color}">${priority}</div></div>`;
      for (var i = 0; i < len; i++) {
        htmls +=
          '<div class="tsk_priority" style="background-color: ' +
          labels[i].color_code +
          '">';
        htmls +=
          '<span title="' +
          labels[i].label +
          '" class="labelSpanCls">' +
          labels[i].label +
          "</span>";
        htmls += "</div>";
      }
      return htmls;
    },
    userImgHtml(users) {
      var len = users.length;
      var htmls = "";
      const defaultImg = this.defaultImage; // 👈 your default image

      for (var i = 0; i < len; i++) {
        if (len <= 3 || i < 2) {
          //   const fallbackText = users[i].initials || users[i].name.charAt(0);
          const imgSrc = users[i].user_image
            ? `${this.img_url}${users[i].user_image}`
            : defaultImg;

          htmls += `
        <div class="mg-thumbnail ${users[i].initials ? "tsk_name" : ""}">
          <img
            src="${imgSrc}"
            alt="${users[i].name}"
            title="${users[i].name}"
            onerror="this.onerror=null; this.src='${defaultImg}'"
          />
        </div>
      `;
        }
      }

      if (len > 3) {
        htmls += `
      <div class="mg-thumbnail tsk_number">
        +${len - 2}
      </div>
    `;
      }

      return htmls;
    },
  },
};
</script>
<style scoped>
.kanPriNameMainCls {
  display: flex;
  justify-content: space-between;
}
/* 0 – 10 minutes (Very Fresh) */
.time-green {
  color: #15803d; /* green-700 */
  background-color: #dcfce7;
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 500;
}

/* 11 – 15 minutes (Fresh) */
.time-light-green {
  color: #16a34a; /* green-600 */
  background-color: #ecfdf5;
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 500;
}

/* 16 – 30 minutes (Recent) */
.time-yellow {
  color: #ca8a04; /* yellow-600 */
  background-color: #fef9c3;
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 500;
}

/* 31 – 45 minutes (Attention) */
.time-orange {
  color: #ea580c; /* orange-600 */
  background-color: #ffedd5;
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 500;
}

/* 46 – 60 minutes (Warning) */
.time-dark-orange {
  color: #c2410c; /* orange-700 */
  background-color: #fed7aa;
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 600;
}

/* 60+ minutes (Delayed / Critical) */
.time-red {
  color: #dc2626; /* red-600 */
  background-color: #fee2e2;
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 600;
}
</style>
